import moment from 'moment';
import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useHistory, useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { formatMoney } from 'utils/objects';
import { postCancelBooking } from '../payment.api';
import { useTranslation } from 'react-i18next';
import useFullPageLoader from 'modules/commons/isn/useFullPageLoader';
import { getQueryString } from 'utils/params';
import { getBooking } from '../payment.api';
import { parseISO, subDays } from 'date-fns';

function CancelBookingComponent(props) {
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const { t } = useTranslation();
  const { bookingConfirmData } = props;
  const [cancelStep, setCancelStep] = useState(1);
  const { language } = useParams();
  const history = useHistory();
  const [reason, setReason] = useState('');
  const [otherChecked, setOtherChecked] = useState(false);
  const [cost, setCost] = useState(0);
  const [cost3, setCost3] = useState('');
  const { bookingNumber } = useParams();

  const handleHideModal = () => {
    setCancelStep(1);
    setReason('');
    props.closeCancel();
  };

  const handleGoListApartment = e => {
    e.preventDefault();
    history.push(`/${language}/serviced-apartments?pageIndex=1&pageSize=15&orderBy=desc&sortBy=2`);
  };

  const handleRadio = e => {
    const { value } = e.target;
    const optionRadio = ['Lý do khác', 'Other', 'その他'];
    if (optionRadio.includes(value)) {
      setOtherChecked(true);
      setReason('');
    } else {
      setReason(value);
      setOtherChecked(false);
    }
  };

  const handleTextarea = e => {
    const { value } = e.target;
    setReason(value);
    // console.log('area');
  };

  const handleStepOne = () => {
    return (
      <>
        <div className="cancel-modal">
          <div className="cancel-modal__title pb-3">{t('payment.label_cancelBooking')}</div>
          <div className="pb-3">
            {t('payment.label_cancelBookingFor', { apartmentName: bookingConfirmData?.detailsApartment?.name })}
          </div>
          <div className="cancel-modal__title pb-2">{t('payment.label_cancelTellUs')}</div>
          <div className="pb-1">
            <div className="cancel-modal__radioBox">
              <label>
                <input
                  type="radio"
                  value={t('payment.label_reason1')}
                  name="cancelReason"
                  onClick={e => handleRadio(e)}
                />
                <span>{t('payment.label_reason1')}</span>
              </label>
            </div>
            <div className="cancel-modal__radioBox">
              <label>
                <input
                  type="radio"
                  value={t('payment.label_reason2')}
                  name="cancelReason"
                  onClick={e => handleRadio(e)}
                />
                <span>{t('payment.label_reason2')}</span>
              </label>
            </div>
            <div className="cancel-modal__radioBox">
              <label>
                <input
                  type="radio"
                  value={t('payment.label_reason3')}
                  name="cancelReason"
                  onClick={e => handleRadio(e)}
                />
                <span>{t('payment.label_reason3')}</span>
              </label>
            </div>
          </div>
          <textarea
            className="area-other-cancel"
            name="otherRequirements"
            rows="6"
            disabled={!otherChecked}
            onChange={e => handleTextarea(e)}
            value={reason}
          ></textarea>
          <div className="d-flex justify-content-center cancel-modal__button">
            <input
              type="button"
              value={t('payment.label_buttonClose')}
              onClick={handleHideModal}
              className="cancel-modal__button-cancel"
            />

            <button disabled={!reason} className="cancel-modal__button-continue" onClick={() => setCancelStep(2)}>
              {t('payment.label_buttonContinue')}
            </button>
          </div>
        </div>
      </>
    );
  };

  const [percent, setPercent] = useState('0%');

  const handleStepTwo = () => {
    const today = Date.now();

    //unixtime sau 7 ngày kể từ ngày checkin
    // const checkFor0 = moment(
    //   subDays(
    //     parseISO(moment(bookingConfirmData?.detailsBookingViewModel?.checkinDate).format('YYYY-MM-DD') + 'T13:59:59'),
    //     7,
    //   ),
    // ).valueOf();
    const checkInValue = moment(
      subDays(
        parseISO(moment(bookingConfirmData?.detailsBookingViewModel?.checkinDate).format('YYYY-MM-DD') + 'T14:00:00'),
        2,
      ),
    ).valueOf();
    const localCurrency =
      bookingConfirmData?.detailsBookingViewModel?.charge + bookingConfirmData?.detailsBookingViewModel?.vat;
    let totalAmount = formatMoney(localCurrency, 0, 0);
    let bookingStatus = '';

    getBooking(getQueryString({ language, bookingNumber })).then(res => {
      // if (res) {
      //   bookingStatus = res.detailsBookingViewModel.bookingStatusId;

      //   if (today < checkFor0) {
      //     setPercent('0%');
      //     setCost('0');
      //   } else if (bookingStatus === 2 && today > checkFor0 && today < checkInValue) {
      //     setPercent('50%');
      //     setCost(formatMoney(localCurrency / 2, 0, 0));
      //   } else if (today > checkInValue) {
      //     setPercent('100%');
      //     setCost(totalAmount);
      //   }
      // }
      if (res) {
        bookingStatus = res.detailsBookingViewModel.bookingStatusId;
        if (bookingStatus === 2 && today < checkInValue) {
          setPercent('50%');
          setCost(formatMoney(localCurrency / 2, 0, 0));
        } else if (today > checkInValue) {
          setPercent('100%');
          setCost(totalAmount);
        }
      }
    });

    return (
      <>
        <div className="cancel-modal">
          <div className="cancel-modal__title pb-3">{t('payment.label_cancelBooking')}</div>
          <div className="pb-3">
            {t('payment.label_cancelBookingFor', { apartmentName: bookingConfirmData?.detailsApartment?.name })}
          </div>
          <div className="d-flex justify-content-between pt-2">
            <div>
              <div className="pb-3">{t('payment.label_localCurrency3')}</div>
              <div className="pb-3">{t('payment.label_%cancelCost')}</div>
              <div>{t('payment.label_cancelCost')}</div>
            </div>
            <div>
              <div className="d-flex justify-content-end pb-3">{totalAmount + 'đ'}</div>
              <div className="d-flex justify-content-end pb-3">{percent}</div>
              <div className="d-flex justify-content-end">
                {/* {currentCurrency?.code === 'USD' ? '$' + cost : currentCurrency?.code === 'VND' ? cost + 'đ' : ''} */}
                {cost + 'đ'}
              </div>
            </div>
          </div>
          <div className="pt-3">
            <span className="required-star">{language === 'jp' ? '※' : '*'}&nbsp;</span>
            <span
              dangerouslySetInnerHTML={{ __html: t('payment.label_refundPolicy') }}
              style={{ display: 'inline' }}
            ></span>
          </div>
          <div className="d-flex justify-content-center cancel-modal__button">
            <input
              type="button"
              value={t('payment.label_buttonClose')}
              onClick={handleHideModal}
              className="cancel-modal__button-cancel"
            />
            <input
              type="button"
              value={t('payment.label_confirmCancel')}
              className="cancel-modal__button-continue"
              onClick={() => handleCancelBooking(percent, cost)}
            />
          </div>
        </div>
      </>
    );
  };

  const handleStepThree = () => {
    return (
      <>
        <div className="cancel-modal">
          <div className="cancel-modal__title pb-3">{t('payment.label_cancelTitle')}</div>
          <div className="pb-3">
            {t('payment.label_cancelBookingFor1', { apartmentName: bookingConfirmData?.detailsApartment?.name })}
          </div>
          <div className="pb-3">{t('payment.label_cancelCheckMail')}</div>
          <div className="d-flex justify-content-between pt-2">
            <div>
              <div>{t('payment.label_cancelCost')}</div>
            </div>
            <div>
              <div className="d-flex justify-content-end">{cost3 + 'đ'}</div>
            </div>
          </div>
          <div className="d-flex justify-content-center cancel-modal__button">
            <input
              type="button"
              value={t('payment.label_buttonClose')}
              onClick={handleHideModal}
              className="cancel-modal__button-cancel"
            />
            <input
              type="button"
              value={t('payment.label_makeAnotherBooking')}
              className="cancel-modal__button-continue"
              onClick={handleGoListApartment}
            />
          </div>
        </div>
      </>
    );
  };

  const handleCancelBooking = (percent, cost) => {
    showLoader();
    const typeCancel = percent === '100%' ? 2 : percent === '50%' ? 1 : '';
    postCancelBooking({
      language,
      bookingNumber: bookingConfirmData?.detailsBookingViewModel?.bookingNumber,
      content: reason,
      typeCancel,
      bookingStatusId: bookingConfirmData?.detailsBookingViewModel?.bookingStatusId,
    }).then(res => {
      if (res === true) {
        setCancelStep(3);
        setCost3(cost);
      } else {
        handleHideModal();
      }
    });
    hideLoader();
  };

  return (
    <Modal id="cancelBooking" centered show={props.showCancel} onHide={handleHideModal} backdrop="static">
      {cancelStep === 1 ? handleStepOne() : cancelStep === 2 ? handleStepTwo() : handleStepThree()}
      {loader}
    </Modal>
  );
}

const mapStatetoProps = state => ({
  ...state,
});

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default connect(mapStatetoProps, mapDispatchToProps)(CancelBookingComponent);
